import { render, staticRenderFns } from "./leadsPerFormAndStudioTable.vue?vue&type=template&id=0ed5696d&scoped=true"
import script from "./leadsPerFormAndStudioTable.vue?vue&type=script&lang=js"
export * from "./leadsPerFormAndStudioTable.vue?vue&type=script&lang=js"
import style0 from "./leadsPerFormAndStudioTable.vue?vue&type=style&index=0&id=0ed5696d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ed5696d",
  null
  
)

export default component.exports